import {createContext, useContext} from 'react';
import {createGlobalStore} from 'use-global-state-react';

// Remember when adding to the Provider to create a type for it below then go to the actual Provider wrapped around app.tsx and pass in your variables.

export type AppContext = {
    token: string
    setToken: (t: string) => void;
    editId: number;
    setEditId: (s: number) => void;
    orgId: number,
    setOrgId: (o: number) => void;
    
}


//The Provider
export const GlobalContext = createContext<AppContext>({
    token: '', // default value
    setToken: () => {}, // useState
    editId: 0, 
    setEditId: () => {},
    orgId: 0,
    setOrgId: () => {}
})

export const useGlobalContext = () => useContext(GlobalContext)

//GlobalStore useGlobalState

const store_key = "id";

export const useServiceId = createGlobalStore<number>(store_key, 0)
